
const plugins = [
    {
      getIdentities: async (context) => [
        {
          id: "hrmless-auth",
          label: "HRMLESS Authentication",
          authorizeRequest: async (request) => {
            const token = await context.authentication?.getAccessToken();
            if (!token) {
              throw new Error("No authentication token available");
            }
            request.headers.set("Authorization", `Bearer ${token}`);
            return request;
          },
        },
      ],
    },
  ] as const

export default plugins;